import {Box} from '@mui/material';
import TextField from '@wearesection/bandai-react-components/molecules/TextField';
import Search from '@wearesection/bandai-react-components/organisms/Search';
import {debounce} from 'lodash';
import {useCallback, useEffect, useRef, useState} from 'react';
import {useSearchBox} from 'react-instantsearch-hooks-web';

const MySearchBox = ({
  onClose,
  isShowSearch,
  propsSearch,
  handleShowHit,
  handleShowTrending,
  getValueSearch,
  locale,
}: {
  onClose?: Function;
  isShowSearch?: boolean;
  propsSearch: any;
  handleShowHit: any;
  handleShowTrending: Function;
  getValueSearch: Function;
  locale: string;
}) => {
  const refTextField = useRef<any>();
  const searchRef = useRef<any>();
  const {query, refine} = useSearchBox();
  const [valueInput, setValueInput] = useState('');

  // handle reset value when component mount
  useEffect(() => {
    if (refTextField.current) {
      refTextField.current.value = '';
      searchRef?.current?.handleSetValueSearch('');
      refTextField.current?.focus();
    }
  }, [isShowSearch]);

  // handel reset search
  const handleRemoveSearch = () => {
    if (refTextField.current) {
      refTextField.current.value = '';
      refTextField.current?.focus();
      searchRef?.current?.handleSetValueSearch('');
      setValueInput('');
    }
  };

  const updateQuery = (e: any) => {
    refine(e);
  };

  const debounceInput = useCallback(
    debounce(nextValue => updateQuery(nextValue), 500),
    []
  );

  const handleInputOnchange = (e: any) => {
    const {value} = e.target;
    if (e.target.value && e.target.value?.length > 2) {
      debounceInput(value);
    }
  };
  return (
    <Box
      sx={{
        marginBottom: '24px',
      }}
    >
      <Search
        ref={searchRef}
        {...propsSearch}
        isShowSearch={isShowSearch}
        handleRemoveSearch={handleRemoveSearch}
        onClose={onClose}
        handleShowTrending={handleShowTrending}
      >
        <TextField
          ref={refTextField}
          value={valueInput}
          label={propsSearch?.placeholder ?? 'Search'}
          width="100%"
          iconPosEnd
          onChange={(e: any) => {
            // // debouncedOnChange(e);
            handleInputOnchange(e);
            // // refine(e.target.value && e.target.value?.length > 2 ? e.target.value : '');
            handleShowHit(
              e.target.value?.length > (locale.toLocaleLowerCase() === 'sea' ? 2 : 0) ? true : false
            );
            getValueSearch(e.target.value);
            setValueInput(e.target.value);
            searchRef?.current?.handleOnChangeInput(e);
          }}
          onFocus={() => searchRef?.current?.handleSetInputFocus(true)}
          onBlur={() => searchRef?.current?.handleSetInputFocus(false)}
        />
      </Search>
    </Box>
  );
};

export default MySearchBox;
